export const validations = (
  isRequired,
  message1,
  maxLength,
  message2,
  minLength,
  message3
) => {
  let validationObject = {};
  if (isRequired) {
    validationObject = {
      ...validationObject,
      required: {
        value: isRequired,
        message: message1,
      },
    };
  }
  if (maxLength) {
    validationObject = {
      ...validationObject,
      maxLength: {
        value: maxLength,
        message: message2,
      },
    };
  }
  if (minLength) {
    validationObject = {
      ...validationObject,
      minLength: {
        value: minLength,
        message: message3,
      },
    };
  }
  return validationObject;
};
